import deLocale from 'element-ui/lib/locale/lang/de'

export default {
  Dashboard: 'Armaturenbrett',
  Analytics: 'Analytics',
  Business: 'Business',
  Method: 'Method',
  Channel: 'Channel',
  Transactions: 'Transaktionen',
  List: 'Aufführen',
  Refund: 'Refund',
  Merchants: 'Kaufleute',
  Commercial: 'Kommerziell',
  Channels: 'Kanäle',
  Management: 'Management',
  Promotions: 'Werbeaktionen',
  Financial: 'Finanziell',
  Payments: 'Zahlungen',
  Download: 'Herunterladen',
  BankBills: 'Bank Bills',
  Query: 'Abfrage',
  AntiFraud: 'Betrugsbekämpfung',
  Anonymous: 'Anonymous',
  Sanctions: 'Sanctions',
  Development: 'Development',
  Calendar: 'Calendar',
  V1Import: 'V1 Import',
  Backdoor: 'Backdoor',
  Settlement: 'Settlement',
  Manual: 'Manual',
  Report: 'Report',
  Invoice: 'Invoice',
  Payout: 'Payout',
  PayoutDownload: 'Download',
  Switcher: 'Switcher',
  Users: 'Users',
  Edit: 'Edit',
  Admin: 'Admin',
  AntiMoneyLaundry: 'AML',
  Review: 'Review',
  Rules: 'Rules',
  Recurring: 'Recurring',
  IdManagement: 'ID Management',
  Blacklist: 'Blacklist',
  RuleManagement: 'Rule Management',
  AmlRuleManagement: 'Rule Management',
  Group: 'Group',
  TongDun: 'TongDun',
  Policy: 'Policy',
  Invoke: 'Invoke',
  RiskTrend: 'Risk Trend',
  KYC: 'KYC',
  APP: 'APP',
  Training: 'Ausbildung',
  Waybill: 'Waybill',
  Upload: 'Upload',
  PayoutAccount: 'Payout Account',
  Registration: 'Registration',
  Reseller: 'Reseller',
  ResellerUsers: 'Resellers',
  ResellerManagement: 'Reseller Management',
  ResellerKyc: 'KYC Management',
  VirtualAccount: 'Virtual Account',
  ...deLocale,
}
